var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  A library for end-to-end encryption (e2ee). This will largely be a wrapper
  for existing encryption libraries.
*/
var BchEncrypt = require('bch-encrypt-lib/index.js');

var EncryptionAdapter = /*#__PURE__*/function () {
  "use strict";

  function EncryptionAdapter() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, EncryptionAdapter);

    // Dependency injection
    this.bch = localConfig.bch;

    if (!this.bch) {
      throw new Error('Must pass in an instance of bch Adapter when instantiating the encryption Adapter library.');
    }

    this.bchjs = this.bch.bchjs; // Copy of bch-js

    this.bchEncrypt = new BchEncrypt({
      bchjs: this.bchjs
    }); // this.ipfs = encryptConfig.ipfs
    // this.orbitdb = encryptConfig.orbitdb
  } // Decrypt incoming messages on the pubsub channel for this node.


  _createClass(EncryptionAdapter, [{
    key: "decryptMsg",
    value: function () {
      var _decryptMsg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(msg) {
        var privKey, decryptedHexStr, decryptedBuff, decryptedStr;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.bch.generatePrivateKey();

              case 3:
                privKey = _context.sent;
                _context.next = 6;
                return this.bchEncrypt.encryption.decryptFile(privKey, msg);

              case 6:
                decryptedHexStr = _context.sent;
                // console.log(`decryptedHexStr ${decryptedHexStr}`)
                decryptedBuff = Buffer.from(decryptedHexStr, 'hex');
                decryptedStr = decryptedBuff.toString(); // console.log(`decryptedStr: ${decryptedStr}`)

                return _context.abrupt("return", decryptedStr);

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                if (!_context.t0.message.includes('Bad MAC')) {
                  _context.next = 16;
                  break;
                }

                throw new Error('Bad MAC. Could not decrypt message. Peer may have stale encryption data for this node.');

              case 16:
                console.error('Error in decryptMsg()');
                throw _context.t0;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function decryptMsg(_x) {
        return _decryptMsg.apply(this, arguments);
      }

      return decryptMsg;
    }() // Returns an encrypted hexidecimal string derived from an input message
    // (string), encrypted with the public key of a peer.

  }, {
    key: "encryptMsg",
    value: function () {
      var _encryptMsg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peer, msg) {
        var pubKey, msgBuf, encryptedHexStr;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                // console.log('peer: ', peer)
                pubKey = peer.data.encryptPubKey; // console.log('msg to encrypt: ', msg)
                // console.log(`Encrypting with public key: ${pubKey}`)

                msgBuf = Buffer.from(msg, 'utf8').toString('hex');
                _context2.next = 5;
                return this.bchEncrypt.encryption.encryptFile(pubKey, msgBuf);

              case 5:
                encryptedHexStr = _context2.sent;
                return _context2.abrupt("return", encryptedHexStr);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error('Error in encryption.js/encryptMsg()');
                throw _context2.t0;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function encryptMsg(_x2, _x3) {
        return _encryptMsg.apply(this, arguments);
      }

      return encryptMsg;
    }() // Send an e2e encrypted message to a peer.
    // async sendEncryptedMsg (peer, msg) {
    //   try {
    //     // console.log('sendEncryptedMsg peer: ', peer)
    //     // console.log('sendEncryptedMsg msg: ', msg)
    //
    //     // const channel = peer.ipfsId.toString()
    //     const pubKey = peer.encryptPubKey
    //     // const orbitdbId = peer.orbitdb
    //
    //     const msgBuf = Buffer.from(msg, 'utf8').toString('hex')
    //     // console.log(`msgBuf: ${msgBuf}`)
    //
    //     const encryptedHexStr = await this.bchEncrypt.encryption.encryptFile(
    //       pubKey,
    //       msgBuf
    //     )
    //     console.log(`encryptedHexStr: ${encryptedHexStr}`)
    //
    //     // const msgBuf2 = Buffer.from(encryptedHexStr, 'hex')
    //
    //     // Publish the message to the pubsub channel.
    //     // TODO: This will be deprecated in the future in favor of publishing to
    //     // the peers OrbitDB.
    //     // await this.ipfs.pubsub.publish(channel, msgBuf2)
    //
    //     // if (orbitdbId) {
    //     //   console.log(
    //     //     `Ready to send encrypted message to peer ${channel} on orbitdb ID ${orbitdbId}`
    //     //   )
    //     //   await this.orbitdb.sendToDb(channel, encryptedHexStr, orbitdbId)
    //     // }
    //   } catch (err) {
    //     console.error('Error in sendEncryptedMsg()')
    //     throw err
    //   }
    // }

  }]);

  return EncryptionAdapter;
}();

module.exports = EncryptionAdapter;